<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="6" lg="7" md="9" cols="12">
            <v-stepper-vertical color="secondary" eager flat :items="steps" v-model="stepper">
                <template #item.1>
                    <v-form @submit.prevent="changeStep()" class="pt-2" ref="step1Form">
                        <v-text-field
                            :rules="$validation('required')"
                            label="* عنوان"
                            v-model="form.name"
                        ></v-text-field>
                        <v-textarea
                            :rules="$validation()"
                            label="توضیحات"
                            no-resize
                            rows="3"
                            v-model="form.description"
                        ></v-textarea>
                    </v-form>
                </template>
                <template #item.2>
                    <v-form @submit.prevent="changeStep()" class="pt-2" ref="step2Form">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    :rules="$validation()"
                                    label="تلفن ثابت"
                                    v-model="form.phone"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    :rules="$validation('url')"
                                    label="وبسایت"
                                    v-model="form.website"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    :items="$system.countries"
                                    @update:modelValue="form.state_id = null; form.city_id = null"
                                    item-title="name"
                                    item-value="id"
                                    label="کشور"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.country_id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    :disabled="form.country_id ? false : true"
                                    :items="$system.states.filter(x=> x.country_id == form.country_id)"
                                    @update:modelValue="form.city_id = null"
                                    item-title="name"
                                    item-value="id"
                                    label="استان"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.state_id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    :disabled="form.state_id ? false : true"
                                    :items="$system.cities.filter(x=> x.state_id == form.state_id)"
                                    item-title="name"
                                    item-value="id"
                                    label="شهر"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.city_id"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-checkbox
                            class="mt-0 pt-0"
                            label="اعمال تنظیمات موقعیت جغرافیایی و سطح سازمان برای کلیه کاربران زیرمجموعه"
                            v-model="form.change_customers"
                        ></v-checkbox>
                        <v-textarea
                            :rules="$validation()"
                            label="آدرس"
                            no-resize
                            rows="3"
                            v-model="form.address"
                        ></v-textarea>
                    </v-form>
                </template>
                <template v-if="haveCustomField" #item.3>
                    <v-form @submit.prevent="changeStep()" class="pt-2" ref="step3Form">
                        <custom-fields-form v-model="form.custom_fields" :items="customFieldItems"></custom-fields-form>
                    </v-form>
                </template>
                <template #[`item.${3+haveCustomField}`]>
                    <v-form @submit.prevent="validate() && submit()" class="pt-2" :ref="`step${3+haveCustomField}Form`">
                        <v-select
                            :rules="$validation('required')"
                            :items="$system.branches"
                            item-title="name"
                            item-value="id"
                            label="* شعبه"
                            no-data-text="موردی پیدا نشد!"
                            :disabled="!form.change_branch"
                            v-if="$auth.user.full_admin"
                            v-model="form.branch_id"
                        ></v-select>
                        <v-autocomplete
                            :rules="$validation('required')"
                            :items="$system.customerLevels"
                            item-title="name"
                            item-value="id"
                            label="* سطح سازمان"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.customer_level_id"
                        ></v-autocomplete>
                        <p class="text-small text-grey-darken-1 mb-4">تکمیل کردن این فیلد باعث می‌گردد پس از تاریخ انقضا دسترسی به سامانه برای مشتریان محدود گردد.</p>
                        <datetime-input
                            :min="maxAssignedExpireDate"
                            type="date"
                            label="تاریخ اتمام دسترسی"
                            clearable
                            v-model="form.expire_date"
                        ></datetime-input>
                        <v-checkbox
                            class="mt-0 pt-0"
                            label="محدود کردن سازمان به دپارتمان"
                            hide-details
                            v-if="$system.license.features.customer_department"
                            v-model="assignedDepartmentCheck"
                            @update:modelValue="!form.assigned_departments.length ? form.assigned_departments.push({department_id: null, meta_data: {expired_at: null, limit: null}}) : null"
                        ></v-checkbox>
                        <div v-if="$system.license.features.customer_department && assignedDepartmentCheck">
                            <v-row dense v-for="(assigned_department ,index) in form.assigned_departments" :key="index" class="mt-4">
                                <v-col cols="12" sm>
                                    <v-autocomplete
                                        :items="departmentList.filter(x => assigned_department.department_id == x.id || !form.assigned_departments.filter(y => y.department_id == x.id).length)"
                                        item-title="name"
                                        item-value="id"
                                        label="انتخاب دپارتمان"
                                        no-data-text="موردی پیدا نشد!"
                                        hide-details
                                        clearable
                                        v-model="assigned_department.department_id"
                                        autocomplete="new-password"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm>
                                    <datetime-input
                                        :max="form.expire_date ? form.expire_date : null"
                                        type="date"
                                        hide-details
                                        label="تاریخ اتمام دسترسی"
                                        clearable
                                        v-model="assigned_department.meta_data.expired_at"
                                    ></datetime-input>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        label="محدودیت تعداد تیکت"
                                        hide-details
                                        v-model="assigned_department.meta_data.limit"
                                        clearable
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn v-tooltip="'حذف دپارتمان'" icon="clear" variant="text" color="error" :disabled="form.assigned_departments.length == 1" @click="form.assigned_departments.splice(index,1)"></v-btn>
                                </v-col>
                            </v-row>
                            <v-btn @click="form.assigned_departments.push({department_id: null,meta_data: {expired_at: null, limit: null}})" :disabled="!!form.assigned_departments.find(x => !x.department_id) || form.assigned_departments.length == departmentList.length" class="rounded d-block mx-auto mt-4" color="secondary" variant="tonal">
                                <v-icon size="18">add</v-icon> افزودن دپارتمان
                            </v-btn>
                        </div>
                        <v-checkbox
                            class="mt-5 pt-0"
                            label="محدود کردن سازمان به محصول/خدمات"
                            hide-details
                            v-if="$system.license.features.customer_department"
                            v-model="assignedServiceCheck"
                            @update:modelValue="!form.assigned_services.length ? form.assigned_services.push({service_id: null, meta_data: {expired_at: null, limit: null}}) : null"
                        ></v-checkbox>
                        <div v-if="$system.license.features.customer_department && assignedServiceCheck">
                            <v-row dense v-for="(assignedService,index) in form.assigned_services" :key="index" class="mt-4">
                                <v-col cols="12" sm>
                                    <v-autocomplete
                                        :items="serviceList.filter(x => assignedService.service_id == x.id || !form.assigned_services.filter(y => y.service_id == x.id).length)"
                                        item-title="name"
                                        item-value="id"
                                        label="انتخاب محصول/خدمات"
                                        no-data-text="موردی پیدا نشد!"
                                        hide-details
                                        clearable
                                        v-model="assignedService.service_id"
                                        autocomplete="new-password"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm>
                                    <datetime-input
                                        :max="form.expire_date ? form.expire_date : null"
                                        type="date"
                                        hide-details
                                        label="تاریخ اتمام دسترسی"
                                        clearable
                                        v-model="assignedService.meta_data.expired_at"
                                    ></datetime-input>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        label="محدودیت تعداد تیکت"
                                        hide-details
                                        v-model="assignedService.meta_data.limit"
                                        clearable
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn v-tooltip="'حذف محصول'" icon="clear" variant="text" color="error" :disabled="form.assigned_services.length == 1" @click="form.assigned_services.splice(index,1)"></v-btn>
                                </v-col>
                            </v-row>
                            <v-btn @click="form.assigned_services.push({service_id: null, meta_data: {expired_at: null, limit: null}})" :disabled="!!form.assigned_services.find(x => !x.service_id) || form.assigned_services.length == serviceList.length" class="rounded d-block mx-auto mt-4" color="secondary" variant="tonal">
                                <v-icon size="18">add</v-icon> افزودن محصول/خدمات
                            </v-btn>
                        </div>
                    </v-form>
                </template>
                <template #title="{title}">
                    <span class="text-meta cursor-pointer font-weight-regular">{{title}}</span>
                </template>
                <template #actions="{step}">
                    <div class="mt-3">
                        <v-btn @click="changeStep(step + 1)" color="success" :loading="loading">{{ step == steps.length ? 'ثبت اطلاعات' : 'ثبت و ادامه'}}</v-btn>
                        <v-btn v-if="step > 1" @click="changeStep(step - 1)" color="error" class="ms-3" variant="text" :disabled="loading">بازگشت</v-btn>
                    </div>
                </template>
            </v-stepper-vertical>
        </v-col>
    </div>
</template>
<script>
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
export default {
    title: "ویرایش",
    validate(context) {
        return context.rbac.can('manage organizations');
    },
    components: {
        VStepperVertical,
    },
    data() {
        return {
            loading: false,
            departmentList: [],
            serviceList: [],
            assignedDepartmentCheck: false,
            assignedServiceCheck: false,
            stepper: 1,
            customFieldItems: [],
            form: {
                name: null,
                branch_id: null,
                customer_level_id: null,
                phone: null,
                website: null,
                country_id: null,
                state_id: null,
                city_id: null,
                change_customers: null,
                expire_date: null,
                address: null,
                description: null,
                change_branch: true,
                custom_fields: [],
                assigned_departments: [],
                assigned_services: []
            },
        };
    },
    computed: {
        maxAssignedExpireDate() {
            let res = null;
            if (this.$system.license.features.customer_department) {
                this.form.assigned_departments.forEach(el => {
                    if(el.meta_data.expired_at && el.meta_data.expired_at > res)
                        res = el.meta_data.expired_at;
                });
                this.form.assigned_services.forEach(el => {
                    if(el.meta_data.expired_at && el.meta_data.expired_at > res)
                        res = el.meta_data.expired_at;
                });
            }
            return res;
        },
        haveCustomField() {
            return this.$system.license.features.organization_custom_field && this.$system.organizationCustomFields.length ? 1 : 0;
        },
        steps() {
            return [
                { title: 'عنوان', value: 1 },
                { title: 'اطلاعات تماس', value: 2 },
            ].concat(
                (this.haveCustomField ? [{ title: 'فیلد های سفارشی', value: 3 }] : []),
                [
                    { title: 'ویژگی های سازمان', value: 3 + this.haveCustomField },
            ]);
        }
    },
    methods: {
        async changeStep(step) {
            for (let i = 1; i < step; i++)
                if (this.$refs[`step${i}Form`] && !(await this.$refs[`step${i}Form`]?.validate())?.valid)
                    return this.stepper = i;
            if (step <= this.steps.length)
                this.stepper = step;
            else
                this.submit();
        },
        submit() {
            this.loading = true;
            let form = JSON.parse(JSON.stringify(this.form));
            if (!this.$auth.user.full_admin) delete form.branch_id;
            if (!this.$system.license.features.customer_department) {
                delete form.assigned_departments;
                delete form.assigned_services;
            } else {
                form.assigned_departments = !this.assignedDepartmentCheck ? [] : form.assigned_departments.filter(x => x.department_id);
                form.assigned_services = !this.assignedServiceCheck ? [] : form.assigned_services.filter(x => x.service_id);
            }
            if (this.haveCustomField)
                form.custom_fields = form.custom_fields.filter(x => x.value !== '' && x.value !== null);
            if (!this.haveCustomField)
                delete form.custom_fields;
            this.$organizationUpdate(this.$route.params.id, form).then(res => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.$router.push({path: '/organization'});
                }
            }).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            if (this.$system.license.features.customer_department) {
                this.departmentList = this.$system.departments.filter(x => ![this.$system.customers_department.id, this.$system.managers_department.id].includes(x.id));
                this.serviceList = this.$system.services;
            }
            await this.$system.setStatesCities();
            this.$organizationGet(this.$route.params.id).then((res) => {
                if (res && res.status == "OK"){
                    let form = { ...res.data };
                    if (this.$system.license.features.customer_department) {
                        this.assignedDepartmentCheck = !!form.assigned_departments.length;
                        this.assignedServiceCheck = !!form.assigned_services.length;
                    }
                    this.form = form;
                    if (this.haveCustomField)
                        this.customFieldItems = this.$system.organizationCustomFields;
                }
            }).finally(() => {this.$loading.finish()});
        });
    },
};
</script>
